import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import * as animation from "@universityofmaryland/web-styles-library/animation";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { wrapTextNodeInSpan } from "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/styles";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import { createVideoObservedAutoPlay } from "../../atomic/assets/video/observed-auto-play.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import { createTextLockupMedium as createTextLockupMedium$1 } from "../../atomic/text-lockup/medium.js";
import "../../atomic/text-lockup/small.js";
const createCompositeHeadline = ({
  headline,
  isThemeDark,
  isThemeMaryland
}) => {
  const characterCount = headline?.textContent?.trim().length || 0;
  const isOverwriteHeadline = characterCount > 30;
  const finalIsThemeDark = isThemeDark || isThemeMaryland;
  if (!headline) return null;
  const headlineStyles = {
    ...typography.sans.compose("largest", {
      theme: theme.fontColor(finalIsThemeDark)
    }),
    ...animation.line.composeSlideUnder({
      color: theme.foreground(finalIsThemeDark)
    })
  };
  return new ElementBuilder(headline).styled(headlineStyles).withStyles({
    element: {
      fontWeight: 800,
      textTransform: "uppercase",
      textWrap: "balance",
      [`@container (${token.media.queries.desktop.min})`]: {
        ...isOverwriteHeadline && {
          fontSize: "40px"
        }
      }
    },
    siblingAfter: {
      marginTop: token.spacing.md
    }
  }).withModifier((el) => wrapTextNodeInSpan(el)).build();
};
const createCompositeStat = ({
  stats
}) => {
  const mediumSize = 800;
  if (!stats) return null;
  const statWrapper = new ElementBuilder().withClassName("text-lockup-medium-stats").withStyles({
    element: {
      marginTop: token.spacing.lg,
      [`&:has(> *:nth-child(2))`]: {
        display: `grid`,
        gridGap: `${token.spacing.md}`
      },
      [`@container (max-width: ${mediumSize - 1}px)`]: {
        marginTop: token.spacing.lg,
        paddingTop: token.spacing.md,
        borderTop: `1px solid ${token.color.gray.light}`
      },
      [`@container (min-width: ${mediumSize}px)`]: {
        marginTop: token.spacing["2xl"],
        [`&:has(> *:nth-child(2))`]: {
          gridGap: `${token.spacing.lg}`,
          gridTemplateColumns: `repeat(2, 1fr)`
        }
      }
    }
  }).build();
  statWrapper.element.innerHTML = stats.innerHTML;
  return statWrapper;
};
const createTextLockupMedium = (props) => createTextLockupMedium$1({
  ...props,
  ribbon: props.eyebrow,
  compositeHeadline: createCompositeHeadline(props),
  compositeStats: createCompositeStat(props)
});
const createAssetContent = (props) => {
  const { dateSign, image, video, isImageScaled = true } = props;
  const children = [];
  if (video) {
    children.push(
      createVideoObservedAutoPlay({
        video,
        isScaled: isImageScaled,
        additionalElementStyles: {
          [`& video`]: {
            objectFit: "cover",
            width: "100%",
            height: "100%"
          }
        }
      })
    );
  }
  if (!video && image) {
    children.push(
      createImageBackground({
        element: image,
        isScaled: isImageScaled,
        isShowCaption: true,
        isGifAllowed: true,
        imageLoading: "lazy",
        dateSign
      })
    );
  }
  return new ElementBuilder().withClassName("pathway-image-container-wrapper").withChildren(...children).withStyles({
    element: {
      position: "relative",
      overflow: "hidden",
      height: "100%",
      width: "100%",
      display: "grid",
      [`&:has(.image-container)`]: {
        alignItems: "center"
      }
    }
  }).build();
};
export {
  createAssetContent,
  createCompositeHeadline,
  createCompositeStat,
  createTextLockupMedium
};
//# sourceMappingURL=_common.js.map
